import React from 'react';

import { SpinnerLoadingContainer } from './SpinnerLoading.styled';

export default function SpinnerLoading(): React.ReactElement {
  return (
    <SpinnerLoadingContainer />
  );
}
